export default __webpack_public_path__ + "9d12a4c3ff9f5c5eee23413f3be1feaf.png";